import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const createSession = (business_details) =>
  api.post("/sessions", { business_details }).then((r) => r.data);

export const getSession = (sessionId) =>
  api.get(`/sessions/${sessionId}`).then((r) => r.data);

export const createTerms = (sessionId) =>
  api.post(`/sessions/${sessionId}/create-terms`).then((r) => r.data);

export const getTermsAccess = (sessionId) =>
  api.get(`/sessions/${sessionId}/terms-access`).then((r) => r.data);

export const getZohoStatus = (sessionId) =>
  api.get(`/sessions/${sessionId}/zoho-status`).then((r) => r.data);

export const getOnboardingAccess = (sessionId) =>
  api.get(`/sessions/${sessionId}/onboarding-access`).then((r) => r.data);

export const submitOnboarding = (sessionId, onboarding_details) =>
  api.post(`/sessions/${sessionId}/onboarding`, { onboarding_details }).then((r) => r.data);

export const updateSessionStatus = (sessionId, status) =>
  api.patch(`/sessions/${sessionId}/status`, { status }).then((r) => r.data);

const sleep = (ms) => new Promise((res) => setTimeout(res, ms));

// Poll the session until it reaches the target status or times out.
export const waitForStatus = async (
  sessionId,
  targetStatus,
  { timeoutMs = 30000, intervalMs = 1500 } = {}
) => {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    const session = await getSession(sessionId);
    if (session.status === targetStatus) return session;
    await sleep(intervalMs);
  }
  throw new Error("timeout");
};
